var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckThank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#D1FADF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0422 16.0117L21.5288 30.9834L17.4122 26.5851C16.6538 25.8701 15.4622 25.8267 14.5955 26.4334C13.7505 27.0617 13.5122 28.1667 14.0322 29.0551L18.9072 36.9851C19.3838 37.7217 20.2072 38.1767 21.1388 38.1767C22.0272 38.1767 22.8722 37.7217 23.3488 36.9851C24.1288 35.9667 39.0138 18.2217 39.0138 18.2217C40.9638 16.2284 38.6022 14.4734 37.0422 15.9901V16.0117Z",
    fill: "#12B76A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckThank);
export default __webpack_public_path__ + "static/media/check-thank.b4156d9feea9580f76d2497347d84082.svg";
export { ForwardRef as ReactComponent };